import { CASE_ACTIONS } from "constants";

export function fetchCasesCount(view) {
    return {
        type: CASE_ACTIONS.FETCH_CASES_COUNT,
        payload: view ? { view } : {}
    };
}

export function fetchedCasesCount(count) {
    return {
        type: CASE_ACTIONS.FETCHED_CASES_COUNT,
        payload: {
            count
        }
    };
}

export function failedFetchCasesCount(error) {
    return {
        type: CASE_ACTIONS.FAILED_FETCH_CASES_COUNT,
        error
    };
}

export function fetchCases(caseStatus) {
    return {
        type: CASE_ACTIONS.FETCH_CASES,
        payload: {
            caseStatus
        }
    };
}

export function fetchedCases(caseStatus, cases) {
    return {
        type: CASE_ACTIONS.FETCHED_CASES,
        payload: {
            caseStatus,
            cases
        }
    };
}

export function failedFetchCases(caseStatus, error) {
    return {
        type: CASE_ACTIONS.FAILED_FETCH_CASES,
        payload: {
            caseStatus
        },
        error
    };
}

export function fetchMoreCases(caseStatus) {
    return {
        type: CASE_ACTIONS.FETCH_MORE_CASES,
        payload: {
            caseStatus
        }
    };
}

export function fetchedMoreCases(caseStatus, cases, hasMore) {
    return {
        type: CASE_ACTIONS.FETCHED_MORE_CASES,
        payload: {
            caseStatus,
            cases,
            hasMore
        }
    };
}

export function failedFetchMoreCases(caseStatus, error) {
    return {
        type: CASE_ACTIONS.FAILED_FETCH_MORE_CASES,
        payload: {
            caseStatus
        },
        error
    };
}

export function downloadCasesXlsx(filters) {
    return {
        type: CASE_ACTIONS.DOWNLOAD_CASES_XLSX, 
        payload: {
            filters
        }
    };
}




